function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function initEventSummary(wrapper) {
  wrapper.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
}

initEventSummary(document);

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
    return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia(wrapper = document, includeProductModel = true) {
  wrapper.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  wrapper.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  wrapper.querySelectorAll('video:not(.video--background)').forEach((video) => video.pause());
  if(includeProductModel) {
    wrapper.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
}

function updateProductMediaStatus(wrapper) {
  wrapper.querySelectorAll('.product__media img').forEach(e => {
    if(e.complete) {
      addLoadedImageStatus(e);
    } else {
      e.onload = () => {
        addLoadedImageStatus(e);
      };
    }
  });
}

function addLoadedImageStatus(image) {
  const parentElement = image.parentElement;
  if(!parentElement.classList.contains('loaded')) {
    parentElement.classList.add('loaded');
    if(parentElement.nextElementSibling) {
      setTimeout(() => parentElement.nextElementSibling.remove(), 500);
    }
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function loadColorSwatches() {
  window.loadedBackgroundColorSwatches = true;
  fetch(window.Shopify.routes.root + `?section_id=background-color-swatches`)
  .then(res => res.text())
  .then((html) => {
    document.body.appendChild(getDomHtmlFromText(html, 'style'));
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json', method = 'POST') {
  return {
    method: method,
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function parseHtml(text) {
  return new DOMParser().parseFromString(text, 'text/html');
}

function getDomHtmlFromText(text, selector) {
  return parseHtml(text)
      .querySelector(selector);
}

function getInnerHtmlFromText(text, selector) {
  return getDomHtmlFromText(text, selector).innerHTML;
}

function closeDetailsInAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(t, e) {
  function n(t, e) {
    return void 0 === t ? e : t
  }

  function o(t, e, o, i) {
    if (e = n(e, 2), o = n(o, ","), i = n(i, "."), isNaN(t) || null == t) return 0;
    var r = (t = (t / 100).toFixed(e)).split(".");
    return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "")
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var i = "",
      r = /\{\{\s*(\w+)\s*\}\}/,
      a = e || moneyFormat;
  switch (a.match(r)[1]) {
    case "amount":
        i = o(t, 2);
        break;
    case "amount_no_decimals":
        i = o(t, 0);
        break;
    case "amount_with_comma_separator":
        i = o(t, 2, ".", ",");
        break;
    case "amount_with_space_separator":
        i = o(t, 2, " ", ",");
        break;
    case "amount_with_period_and_space_separator":
        i = o(t, 2, " ", ".");
        break;
    case "amount_no_decimals_with_comma_separator":
        i = o(t, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        i = o(t, 0, " ");
        break;
    case "amount_with_apostrophe_separator":
        i = o(t, 2, "'", ".")
  }
  return a.replace(r, i)
}

Shopify.showPrice = function(price, noConvert = false) {
  return (!noConvert) ? Shopify.formatMoney(price * Shopify.currency.rate) : Shopify.formatMoney(price);
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    HTMLUpdateUtility.reinjectsScripts(element);
  }

  static reinjectsScripts(element) {
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class DrawerFixed extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close(evt));
    this.stickyHeader = document.querySelector('sticky-header');
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : (this.classList.contains('drawer--cart') ? document.getElementById('CartDrawer') : document.getElementById('QuickAddDrawer'));
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('open-drawer-fixed');
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return getInnerHtmlFromText(html, selector);
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return getDomHtmlFromText(html, selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  close(evt) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('open-drawer-fixed');
    setTimeout(() => {
      document.body.dispatchEvent(new CustomEvent('drawerClosed'));
    }, 500);
  }
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.removeAttribute('hidden');
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.classList.add('closing');
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
      this.classList.remove('closing');
    }, 600);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.dataset.modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector('[id^="Slider-"]')) return;
    this.init();
  }

  init() {
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) return;
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = (this.dataset.outsidePrevButtonId != undefined ? this.closest('[id^="shopify-section"]').querySelector(`#${this.dataset.outsidePrevButtonId}`) : this.querySelector('button[name="previous"]'));
    this.nextButton = (this.dataset.outsideNextButtonId != undefined ? this.closest('[id^="shopify-section"]').querySelector(`#${this.dataset.outsideNextButtonId}`) : this.querySelector('button[name="next"]'));
    this.isAutoplay = this.slider.dataset.autoplay === 'true';
    this.autoplayButtonQuerySelector = '.slider__autoplay';
    this.autoPlayPausedClass = 'slider__autoplay--paused';
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');

    this.initPages();

    if(this.nextButton) {
      this.onButtonClickHandler = this.onButtonClick.bind(this);
      this.prevButton.addEventListener('click', this.onButtonClickHandler);
      this.nextButton.addEventListener('click', this.onButtonClickHandler);
    }

    if (this.isAutoplay) this.setAutoPlay();

    if(this.sliderControlButtons) {
      this.sliderControlLinksArray = Array.from(this.sliderControlButtons);
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    }

    window.addEventListener('resize', debounce((event) => {
      this.initPages();
    }), true);

    this.slider.addEventListener('scroll', () => { if (this.sliderItemsToShow?.length > 1) this.update(); });
  }

  disconnectedCallback() {
    if(this.nextButton) {
      this.prevButton.removeEventListener('click', this.onButtonClickHandler);
      this.nextButton.removeEventListener('click', this.onButtonClickHandler);
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      this.sliderItemOffset = 0;
      this.slidesPerPage = this.sliderItemsToShow.length;
      this.totalPages = this.sliderItemsToShow.length;
      this.currentPage = this.sliderItemsToShow.length;
      if (this.currentPageElement) this.currentPageElement.textContent = this.currentPage;
      if (this.pageTotalElement) this.pageTotalElement.textContent = this.totalPages;
      if (this.prevButton) this.prevButton.setAttribute('disabled', 'disabled');
      if (this.nextButton) this.nextButton.setAttribute('disabled', 'disabled');
      return;
    }
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    const slidersPerPageInFloat = this.slider.clientWidth / Math.abs(this.sliderItemOffset);
    this.slidesPerPage = Math.ceil(slidersPerPageInFloat);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.sliderControlButtons.length) {
      const limit = this.sliderItemsToShow.length - this.slidesPerPage;
      this.sliderControlButtons.forEach((link, indexLink) => {
        link.classList.remove('hidden');
        if(indexLink > limit) {
          link.classList.add('hidden');
        }
      });
    }
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.sliderItemsToShow || this.sliderItemsToShow.length < 2) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage && this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    if (this.isAutoplay && this.autoplayButtonIsSetToPlay) this.play();

    if (this.enableSliderLooping || !this.nextButton) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft < 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!this.slider || !element) return false;
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth - 1) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(this.autoplayButtonQuerySelector);
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    if(this.sliderAutoplayButton) {
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    }

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  linkToSlide(event) {
    event.preventDefault();
    this.goToSlideByTarget(event.currentTarget);
  }

  goToSlideByTarget(target) {
    const slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset * (this.sliderControlLinksArray.indexOf(target) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  autoPlayToggle() {
    this.togglePlayButtonState();
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearTimeout(this.autoplay);
    this.autoplay = setTimeout(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearTimeout(this.autoplay);
  }

  togglePlayButtonState() {
    if(!this.sliderAutoplayButton) return;
    if (!this.autoplayButtonIsSetToPlay) {
      this.sliderAutoplayButton.classList.add(this.autoPlayPausedClass);
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove(this.autoPlayPausedClass);
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.totalPages ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.sectionId = this.dataset.originalSection || this.dataset.section;
  }

  onVariantChange(event) {
    const target = this.getInputForEventTarget(event.target);
    this.publishChangeEvent(target);
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    const valueIds = [];
    this.querySelectorAll('select').forEach((select) => {
      valueIds.push(select.options[select.selectedIndex].dataset.optionValueId);
    });
    return valueIds;
  }

  publishChangeEvent(target, recall = false, customSelectedOptionValues = null) {
    const params = {
      sectionId: this.dataset.section,
      target: target,
      selectedOptionValues: (customSelectedOptionValues) ? customSelectedOptionValues : this.selectedOptionValues,
    };
    if(recall) {
      params.recallId = this.dataset.section;
    }
    document.dispatchEvent(new CustomEvent('optionValueSelectionChange', {detail: params}));
  }

  autoCorrectAvailableVariant(newProductInfoNode) {
    const newSelectedOptionValues = [];
    var findSelectedOptionValue;
    var stopFinding = false;
    newProductInfoNode.querySelectorAll('.product-form__input--variant-picker').forEach(fieldset => {
      if(stopFinding == false) {
        if(!fieldset.classList.contains('last')) {
          const currentSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"]:checked, option:not(.hidden)[selected]');
          if(currentSelectedOptionValue) {
             newSelectedOptionValues.push(currentSelectedOptionValue.dataset.optionValueId);
          } else {
            const altCurrentSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"], option:not(.hidden)');
            newSelectedOptionValues.push(altCurrentSelectedOptionValue.dataset.optionValueId);
            stopFinding = true;
          }
        } else {
          findSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"]:not(:checked), option:not(.hidden):not([selected])');
          if(!findSelectedOptionValue) {
            findSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"]:checked, option:not(.hidden)[selected]');
          }
          newSelectedOptionValues.push(findSelectedOptionValue.dataset.optionValueId);
        }
      } else {
        const currentSelectedOptionValue = fieldset.querySelector('li input[type="radio"]:checked, option[selected]');
        newSelectedOptionValues.push(currentSelectedOptionValue.dataset.optionValueId);
        if(fieldset.classList.contains('last')) {
          findSelectedOptionValue = currentSelectedOptionValue;
        }
      }
    });
    this.publishChangeEvent(document.getElementById(findSelectedOptionValue.id), true, newSelectedOptionValues);
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.legend = this.querySelector('legend');
    this.submitButton = document.querySelector('.product-form__submit.button')
  }

  connectedCallback() {
    this.loadBackgroundColorSwatches();

    if (this.dataset.disableSelectedVariantWhenNoParam == 'true') {
      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get('variant');
      if (variantParam === null || variantParam.trim() === '') {
        const checked = this.querySelector('input[type="radio"]:checked')
        checked?.removeAttribute('checked')
        this.legend.style.display = 'none';
        this.submitButton.setAttribute('disabled', 'disabled');
        this.addEventListener('change', this.onVariantChanged.bind(this));
      }
    }
  }

  onVariantChanged() {
    this.legend.style.display = 'block';
    this.submitButton.removeAttribute('disabled');
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('input[type="radio"]:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  loadBackgroundColorSwatches() {
    if(!window.loadedBackgroundColorSwatches && this.querySelectorAll('.product-form__input__radio-label--color').length > 0) {
      loadColorSwatches();
    }
  }
}

customElements.define('variant-radios', VariantRadios);

const deferredMediaObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting) {
      entry.target.loadContent(false);
    } else {
      entry.target.pause();
    }
  });
});

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if(this.dataset.ignore) {
      return;
    }
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
    const videoRatio = this.isMobile ? this.dataset.mobileVideoRatio : this.dataset.desktopVideoRatio
    if (videoRatio) {
      this.style.setProperty('--video-ratio', videoRatio);
    }
    this.defaultMuted = this.dataset.defaultMuted !== 'false';
    this.showMutedIcon = this.dataset.mutedIcon === 'true';
    this.isPlaying = false;
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));

    if(this.dataset.autoplay) {
      deferredMediaObserver.observe(this);
    }

    if (this.showMutedIcon) {
      this.initVolumeButton()
    }
  }

  initVolumeButton() {
    this.volume = document.createElement('div')
    this.volume.className = 'volume-btn'
    this.volume.innerHTML = `
    <img class="vol-open" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJiSURBVHgBzViBUcMwDFQ5BsgI3oBu0DABjBAmaDegG9ANChMAEzRMUDaIN2iZQMhEAtV1asdNc/ydzrEtKW/ZseUA/DNM4AwgYkGFE8NNexI7mUz2MBaIREnyRNJgN7Yka6cLlwI5ryIkutA429T3RKeMnE2pWJNMVbObkprkg8Ry3UGmb0ZScl3g9G5pOi3kgsjMSXb+aHntpNiHorqAHJDho3Kyy3bU+lp6pB77Oph7UZnCmSAfxotW2gDZUJMxMBA8UrukgXqjMJAI55zkFdstYYHt9lB06Mm63MacVorMEnqA9DcYRuMTY8KC6pTTRpxAT5wghKGpib6LQxxnHSfkyoL9uUjcd+jr2ShDCmvu3EEGNKFEfUda1tJK2q+UjoT1A0YAH8A1V+9AE+JFJ4RqGA8yeMMcfiNklJKF8WDV8w+ha11hdOYyKpJloNtAf+w9e3udasmf7ivkvTgZQsiqttDuaqjYhPrOxNHMXOkKwwQMF8rY5TRHgLyPwahn+0uIP0HLHWXA8IbLmnRrGA4zLj8lD9f70Lso4fGhKBE8dTobLr8gHaUQkga9qN9I5tBOTUWyUn2OrDsCCj57XjzHM0XoDRLAx5MM/KVLqek68KjtGeN4hkRgykHuHXiLjv5tgMgGe6S4eJgeVzFleWFaRtcT6GWkKQY6o2vwciksJvvGw4xuEFI80ObUkog5WOIh+l1dDn3597sl5MCLlESrSrQt2L5R9tH7XcpV2kB7jhnVnHOVdpvfA+3InzAEcKSfDTnEXPLuNslthMQKM37HDPHDysDf1FiS/ag/rC6NbwRmCS1CJFgXAAAAAElFTkSuQmCC" />
    <img class="vol-close" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKhSURBVHgBzViNsZswDHbeZQBG8AjZoHSDbhA6QbPBY4O+DaATpBuknYC3gdkg2UCVilWEsbGc5Hrvu9MZLEv+/CcZjPlg2PEDAFRYVLvdbtQasw2K9VU3lBF93MwjQMcWZhwzbWuU7ygO0hhQOmpr7iRUBQ6PkTZNhkQKjmy1XOSSNVh0Qtfg1P/A+oOvPwgdLckvlN8oo38n8PJ9Qqn9O4PafS7ZEjwLEh3KNRwtTHtH688FPk+mBBFS4EmVOVr6bAN/r6UOusBBax4ETAfHFc8ULE+cxNE8iIAUzfpBYyRH0WpJkXOUM0wh4QRTeKgS7XhfDjkyTbhMsN5Tx4TtBeJwITFPmNEYxey4DaJRUhuECAdtX7JBvcU6R0oQorLy/mgmviT6k/7qWIPOK68mgS1SkpBRwJPmvfQWazB45c+MoyipUkLe5hxdNljmsmx8iJG6k5Dc3H83/t7rrGg35hxhPurRAT1y7uvNnM9KMIpnInTbixdG0rEfBZ2Y2le9mznpqvJbANmXJYJ7rSVMR/dslrP5dLz4chR1sehqsbgoydSgTzOrlXmRLx42YngSxnSnWcFM9yNGryRlxfO40MAcOVfHXnOCIB6pc9dhPvZDTPnmlVdY5x423AqajmOKlhTMgbGLKetULAriDnXYBnIR+gZ0uW87dYSjjOh6yKNPdLgiBbnkGnFySuiHCJHLRvsVKSxfRV1jtiA61N3oMoiQasWz0ziQNzoHUwx6NimG1TqQSe9ZpNqATPeog7JPl6Wvb7D8vmOUfTgEM8Wz1ShtK2/vhD2R6rdI7RSOrVnnsXs+pelm8BWzzDskPttNCeDJPxtgvdHvub78i+g07UOGBKWi2uQHybBUl12yjENeIh7diHIr+WHliRTZ/Ff8AetOXt7EnkWGAAAAAElFTkSuQmCC" />
    `
    this.appendChild(this.volume)
    if (this.defaultMuted) {
      this.volume.classList.remove('open')
    } else {
      this.volume.classList.add('open')
    }
    this.volume.addEventListener('click', (e) => {
      this.videoMuted()
      e.stopPropagation()
      e.stopImmediatePropagation()
      e.preventDefault()
    })
  }

  videoMuted(muted) {
    if(this.deferredElement.nodeName == 'VIDEO') {
      if (muted === undefined) {
        muted = !this.deferredElement.muted
      }
      this.deferredElement.muted = muted;
      if (this.volume) {
        if (muted) {
          this.volume.classList.remove('open')
        } else {
          this.volume.classList.add('open')
        }
      }
    }
  }

  loadContent(focus = true, play = false) {
    if (!this.deferredElement) {
      if(!this.hasAttribute('loaded')) {
        const content = document.createElement('div');
        const templateContent = this.querySelector('template').content
        const videoDiv = templateContent.querySelector(this.isMobile ? '.mobile-video' : '.desktop-video')
        if (videoDiv) {
          content.appendChild(videoDiv.cloneNode(true))
        } else {
          content.appendChild(templateContent.firstElementChild.cloneNode(true));
        }

        this.setAttribute('loaded', true);
        this.deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      } else {
        this.deferredElement = this.querySelector('video, model-viewer, iframe');
      }
    }
    if(this.deferredElement) {
      if(this.deferredElement.nodeName == 'VIDEO') {
        this.videoMuted(this.defaultMuted)
      }
      if (focus) this.deferredElement.focus();
      if (this.deferredElement.getAttribute('autoplay') || this.dataset.autoplay || play) {
        // force autoplay for safari
        this.play();
      }
    }
  }

  play() {
    if(this.isPlaying) return;
    if(this.deferredElement.nodeName == 'VIDEO') {
      this.deferredElement.play();
    } else if(this.deferredElement.classList.contains('js-youtube')) {
      this.deferredElement.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    } else if(this.deferredElement.classList.contains('js-vimeo')) {
      this.deferredElement.contentWindow.postMessage('{"method":"play"}', '*');
    }
    this.isPlaying = true;
  }

  pause() {
    if(this.deferredElement && this.isPlaying) {
      window.pauseAllMedia(this);
      this.isPlaying = false;
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class BtStorageUtil {
  static set(key, value, isSession) {
    if (isSession) {
      sessionStorage.setItem(
        `bt-${key}`,
        typeof value === 'object' ? JSON.stringify(value) : value
      );
    } else {
      localStorage.setItem(`bt-${key}`, typeof value === 'object' ? JSON.stringify(value) : value);
    }
  }

  static get(key, isJson, isSession) {
    const value = isSession ? sessionStorage.getItem(`bt-${key}`) : localStorage.getItem(`bt-${key}`);
    if (isJson) {
      return JSON.parse(value);
    }
    return value;
  }

  static remove(key, isSession) {
    if (isSession) {
      sessionStorage.removeItem(`bt-${key}`);
    } else {
      localStorage.removeItem(`bt-${key}`);
    }
  }
}


class ProductTabComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.querySelectorAll('.tab-item').forEach(tabItem => {
      tabItem.addEventListener('click', this.onTabItemClick.bind(this))
    })
    this.setupWindowResizeEvent()
    // 需要等待一会儿，不然sticky-header.calculateHeaderHeight()无法执行
    setTimeout(() => {
      this.initTop()
    }, 1000)
  }

  initTop() {
    const header = document.querySelector('sticky-header')
    if (header && header.calculateHeaderHeight) {
      this.querySelector('.tab-nav').style.top = header.calculateHeaderHeight() + 'px'
    } else {
      const navHeight = document.querySelector('header.header').clientHeight
      this.querySelector('.tab-nav').style.top = navHeight + 'px'
    }
  }

  setupWindowResizeEvent() {
    this.debouncedOnWindowResize = debounce((event) => {
      this.onWindowResize(event);
    }, 500);

    window.addEventListener('resize', this.debouncedOnWindowResize, false);
  }

  onWindowResize () {
    this.initTop()
  }

  onTabItemClick(event) {
    event.preventDefault()

    this.clearActive()
    const currentTabId = event.target.dataset.tab
    event.target.classList.add('active')
    const tabContent = this.querySelector(`.content-item[data-tab="${currentTabId}"]`)
    tabContent.classList.add('active')

    const container = this.closest('.product-tab-sticky-background')
    container.classList.remove.apply(container.classList, Array.from(container.classList).filter(v=>v.startsWith('bbb-')));
    container.classList.add('bbb-' + currentTabId)
  }

  clearActive() {
    this.querySelectorAll('.tab-item').forEach(tabItem => {
      tabItem.classList.remove('active')
    })
    this.querySelectorAll('.content-item').forEach(tabItem => {
      tabItem.classList.remove('active')
    })
  }
}
customElements.define('product-tab-component', ProductTabComponent)


class SplideSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const options = {
      gap: '10px',
      perPage: 5,
      perMove: 1,
      pagination: false,
      arrows: true,
      destroy: false,
      mediaQuery: 'max'
    }
    if (this.dataset.destroy) options.destroy = this.dataset.destroy === 'true'
    if (this.dataset.type) options.type = this.dataset.type
    if (this.dataset.role) options.role = this.dataset.role
    if (this.dataset.label) options.label = this.dataset.label
    if (this.dataset.gap) options.gap = this.dataset.gap
    if (this.dataset.autoWidth) options.autoWidth = this.dataset.autoWidth
    if (this.dataset.autoHeight) options.autoHeight = this.dataset.autoHeight
    if (this.dataset.perPage) options.perPage = parseInt(this.dataset.perPage)
    if (this.dataset.perMove) options.perMove = parseInt(this.dataset.perMove)
    if (this.dataset.pagination) options.pagination = this.dataset.pagination === 'true'
    if (this.dataset.padding) {
      if (this.dataset.padding.includes('{')) {
        options.padding = JSON.parse(this.dataset.padding)
      } else {
        options.padding = this.dataset.padding
      }
    }
    if (this.dataset.arrows) options.arrows = this.dataset.arrows === 'true'
    if (this.dataset.mediaQuery) options.mediaQuery = this.dataset.mediaQuery
    if (this.dataset.destroy) options.destroy = this.dataset.destroy === 'true' ? true : this.dataset.destroy
    if (this.dataset.breakpoints) options.breakpoints = JSON.parse(this.dataset.breakpoints)

    new Splide(this, options).mount();
  }
}

customElements.define('splide-slider', SplideSlider)


class CardProductOptions extends HTMLElement {
  constructor() {
    super();
    this.selectedColorValue = null
    this.productOptionNames = this.dataset.productOptions ? this.dataset.productOptions.split(',') : []
    this.colorOptionName = this.dataset.swatchColorName
    this.colorOptionIndex = this.productOptionNames.indexOf(this.colorOptionName)
  }

  connectedCallback() {
    // 颜色选项改变事件
    const productColors = this.closest('.card--product').querySelector('card-product-colors')
    if (productColors) {
      const isTouchDevice = 'ontouchstart' in window
      const colorOptions = productColors.querySelectorAll('a.card__product-color-list__button--variant')
      if (colorOptions && colorOptions.length > 0) {
        this.selectedColorValue = colorOptions[0].dataset.colorOption
        colorOptions.forEach(a => {
          a.addEventListener('click', this.onProductColorSelectedChanged.bind(this))
          if (!isTouchDevice) {
            a.addEventListener('mouseover', this.onProductColorSelectedChanged.bind(this))
          }
        })
      }
    }


    this.loadingElement = this.querySelector('.breath-container')
    this.addToCardButton = this.querySelector('.btn-quick-add')
    this.addToCardButton.addEventListener('click', this.onAddToButtonClick.bind(this))
    // 获取product.variants json数据
    const scriptTag = this.querySelector('script[type="application/json"]')
    this.variants = JSON.parse(scriptTag.textContent)

    this.optionsList = this.getOptionsDimensions(this.variants)
    // 如果维度大于1，那么点击选项时，不会立即触发添加到购物车函数，需要手动点击"添加"按钮。
    this.shouldClickAddToButton = this.optionsList.length > 1

    // 渲染变体选项
    this.optionListElement = this.querySelector('.option-list')
    for (const options of this.optionsList) {
      const ul = document.createElement('ul')
      this.optionListElement.appendChild(ul)
      let first = true
      for (const option of options) {
        const li = document.createElement('li')
        if (first) {
          li.classList.add('selected')
          first = false
        }
        li.innerText = option
        li.dataset.value = option
        li.addEventListener('click', this.onOptionItemClick.bind(this))
        ul.appendChild(li)
      }
    }

    if (this.optionsList.length === 1 && this.optionsList[0].length > 1) {
      this.addToCardButton.style.display = 'none'
    }
    if (this.optionsList.length === 0 || this.variants.length <= 1) {
      this.optionListElement.remove()
    }
    if (this.selectedColorValue == null && this.optionsList.length === 0) {
      this.remove()
    }

  }

  onOptionItemClick (e) {
    e.target.parentElement.querySelectorAll('li.selected').forEach(li => li.classList.remove('selected'))
    e.target.classList.add('selected')
    if (!this.shouldClickAddToButton) {
      this.addToCard()
    } else {
      this.onProductOptionChanged()
    }
  }

  onProductColorSelectedChanged (e) {
    const a = e.target.closest('a.card__product-color-list__button--variant')
    if (a) {
      this.selectedColorValue = a.dataset.colorOption || ''
    }
    this.onProductOptionChanged()
  }

  // 当任何一个维度的选项的"选中"状态变更时，重新计算"sold out"。
  onProductOptionChanged () {
    const selectedColorVariants = this.selectedColorValue ?
      this.variants.filter(v => isStringInArrayIgnoreCase(this.selectedColorValue, v.options)) :
      this.variants

    const optionContainerElements = this.querySelectorAll('.option-list ul')

    let selectedOption1Value = null
    if (optionContainerElements.length > 0) {
      optionContainerElements[0].querySelectorAll('li').forEach(li => {
        const optionValue = li.dataset.value
        if (selectedOption1Value == null && li.classList.contains('selected')) {
          selectedOption1Value = optionValue
        }
        if (selectedColorVariants.filter(v => v.options.includes(optionValue) && v.available).length > 0) {
          // 有库存
          li.classList.remove('sold-out')
        } else {
          li.classList.add('sold-out')
        }
      })
    }

    if (optionContainerElements.length > 1) {
      optionContainerElements[1].querySelectorAll('li').forEach(li => {
        const optionValue = li.dataset.value
        const filterList = selectedColorVariants.filter(v => {
          return v.options.includes(optionValue) && v.options.includes(selectedOption1Value) && v.available
        })
        if (filterList.length > 0) {
          // 有库存
          li.classList.remove('sold-out')
        } else {
          li.classList.add('sold-out')
        }
      })
    }

  }

  onAddToButtonClick () {
    this.addToCard()
  }

  /*
    将产品的变体转换成多维选项值。
    比如某个产品有三个选项Color（Black, Blue）, Size（XS, S, M, L）, Other（A, B），则返回二维数组如下：
    [
     [Black, Blue],
     [XS, S, M, L],
     [A, B]
    ]
    删除颜色维度，最终返回如下：
    [
     [XS, S, M, L],
     [A, B]
    ]
   */
  getOptionsDimensions (variants) {
    const dimensions = [];

    // 使用传统 for 循环保证浏览器兼容性
    for (let v = 0; v < variants.length; v++) {
      const options = variants[v].options;

      // 遍历每个选项维度
      for (let i = 0; i < options.length; i++) {
        const value = options[i];

        // 跳过空值 (null/undefined)
        if (value == null) continue;

        // 初始化维度数组
        if (!dimensions[i]) dimensions[i] = [];

        // 检查是否已存在该值
        let exists = false;
        for (let j = 0; j < dimensions[i].length; j++) {
          if (dimensions[i][j] === value) {
            exists = true;
            break;
          }
        }

        // 添加唯一值
        if (!exists) {
          dimensions[i].push(value.toString()); // 保证字符串类型
        }
      }
    }

    const tmp = []
    for (let i = 0; i < dimensions.length; i++) {
      if (i !== this.colorOptionIndex) {
        tmp.push(dimensions[i])
      }
    }

    return tmp;
  }

  async addToCard () {
    const selectedOptions = []
    if (this.selectedColorValue) {
      selectedOptions.push(this.selectedColorValue)
    }
    this.optionListElement.querySelectorAll('li.selected').forEach(li => {
      selectedOptions.push(li.dataset.value)
    })
    let selectedVariant = null
    for (const v of this.variants) {
      if (areArraysEqualIgnoreCaseAndOrder(v.options, selectedOptions)) {
        selectedVariant = v
        break
      }
    }
    if (selectedVariant == null) {
      return
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items')

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    formData.append('items[][id]', selectedVariant.id);
    formData.append('items[][quantity]', 1);
    config.body = formData;

    this.loadingElement.classList.add('loading')
    let response = await fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          pushErrorMessage(response.description)
          document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: selectedVariant.id,
              errors: response.errors || response.description,
              message: response.message
            }}));
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        pushSuccessMessage(window.cartStrings.success);
        cart.renderContents(response)
        document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {
            productVariantId: selectedVariant.id,
            source: 'card-product',
            cartData: response
          }}));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.loadingElement.classList.remove('loading')
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
  }
}

customElements.define('card-product-options', CardProductOptions)



class SectionImageSlider extends HTMLElement {
  connectedCallback() {
    this.style.display = 'block'

    this.querySelectorAll('.image-slider__item-wrapper').forEach(item => {
      const contentHeight = item.querySelector('.image-slider__item-content').offsetHeight;
      item.style.setProperty('--content-height', `${contentHeight}px`);
    });
  }
}

customElements.define('section-image-slider', SectionImageSlider)

class PopupVideoPlayer extends HTMLElement {
  constructor() {
    super()
    this.classList.add('popup-video-player')
    this.hideListener = this.hidePopup.bind(this)
  }

  #renderBaseUI() {
    this.innerHTML = `
      <div class="popup-player-container">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" width="30" height="30" viewBox="0 0 22 22" fill="none">
            <path d="M5.5 16.5L16.5 5.5M5.5 5.5L16.5 16.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg class="loading-spinner" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 4C35.4934 4 44 12.5066 44 23C44 33.4934 35.4934 42 25 42C14.5066 42 6 33.4934 6 23C6 12.5066 14.5066 4 25 4ZM25 8C16.7157 8 10 14.7157 10 23C10 31.2843 16.7157 38 25 38C33.2843 38 40 31.2843 40 23C40 14.7157 33.2843 8 25 8Z" fill="#FFF" fill-opacity="0.2"/>
            <path d="M25 4C35.4934 4 44 12.5066 44 23C44 24.3807 42.8807 25.5 41.5 25.5C40.1193 25.5 39 24.3807 39 23C39 14.7157 31.2843 7 23 7C21.6193 7 20.5 5.88071 20.5 4.5C20.5 3.11929 21.6193 2 23 2C23.3407 2 23.6748 2.0246 24.0024 2.07217C24.3308 2.11989 24.652 2.1901 24.9645 2.28164L25 4Z" fill="#FFF"/>
          </svg>
          <div class="player-wrapper"></div>
      </div>
    `;
    this.container = this.querySelector('.popup-player-container');
    this.closeButton = this.container.querySelector('.icon-close');
    this.playerWrapper = this.container.querySelector('.player-wrapper');
    this.loadingSpinner = this.container.querySelector('.loading-spinner');
  }

  onPlayButtonClick(e) {
    const playerEl = e.target.closest('[data-video-player]')
    this.setVideoRatio(playerEl.dataset.videoRatio)
    const url = playerEl.dataset.videoUrl
    if (url) {
      this.play(url)
    }
  }

  getPlayerId() {
    /*
      子类需实现，返回全局定义的播放器id，如：
      <youtube-player id="video-slider-youtube-player"></youtube-player>
      <tiktok-player id="video-slider-tiktok-player"></tiktok-player>
      youtube播放器就返回video-slider-youtube-player
    */
  }

  play(url) {
    // 子类需实现
  }

  stopPlay() {
    // 子类需实现，停止播放或销毁平台播放器
  }
  

  connectedCallback () {
    this.#renderBaseUI();
    this.closeButton.addEventListener('click', this.hideListener);
    this.playButtonListener = this.onPlayButtonClick.bind(this)
    document.querySelectorAll(`[data-video-player="${this.getPlayerId()}"]`).forEach(el => {
      el.addEventListener('click', this.playButtonListener)
    })
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener('click', this.hideListener);
    document.querySelectorAll(`[data-video-player="${this.getPlayerId()}"]`).forEach(el => {
      el.removeEventListener('click', this.playButtonListener)
    })
  }

  showPopup() {
    this.style.display = 'block';
  }

  hidePopup() {
    this.style.display = 'none';
    this.stopPlay()
  }

  setVideoRatio(ratioClass) {
    this.container.classList.remove('landscape', 'portrait')
    this.container.classList.add(ratioClass)
  }
}

/*
  播放youtube视频的模态框视频播放器。
  用法：
  <div>
    <button data-youtube-player="youtube-player"
            data-youtube-url="https://www.youtube.com/watch?v=g9uSdVTEiHI">Play</button>
    <button data-youtube-player="youtube-player"
            data-youtube-url="https://www.youtube.com/watch?v=41251123455">Play</button>
    <youtube-player id="youtube-player"></youtube-player>
  </div>

  注1：<youtube-player>会从它的父元素开始查找[data-youtube-player]的元素，并为其添加点击事件。
  注2：[data-youtube-player]的值必须和<youtube-player>的id相同。
 */
class YoutubePlayer extends PopupVideoPlayer {

  static #isApiLoading = false;
  static #isApiLoaded = false;

  constructor() {
    super();
    
  }

  connectedCallback () {
    this.#initPlayerAPI();
    super.connectedCallback()
  }

  getPlayerId() {
    return "video-slider-youtube-player"
  }

  /**
   * @param url {String} 例：https://www.youtube.com/watch?v=VRjsniOpTWk
   */
  play (url) {
    this.videoId = this.#parseVideoId(url);
    if (this.videoId && YoutubePlayer.#isApiLoaded) {
      this.showPopup()
      if (this.player) {
        this.player.loadVideoById(this.videoId);
      } else {
        this.#createPlayer();
      }
    }
  }

  stopPlay() {
    if (this.player) this.player.stopVideo();
  }

  #initPlayerAPI() {
    if (YoutubePlayer.#isApiLoaded) return;
    if (!YoutubePlayer.#isApiLoading) {
      YoutubePlayer.#isApiLoading = true;
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(script);
    }
    window.onYouTubeIframeAPIReady = () => {
      YoutubePlayer.#isApiLoaded = true;
    };
  }

  #createPlayer() {
    this.player = new YT.Player(
        this.playerWrapper,
        {
          videoId: this.videoId,
          playerVars: {
            autoplay: 1,
            origin: location.origin,
            enablejsapi: 1,
            modestbranding: 1
          },
          events: {
            'onReady': (e) => e.target.playVideo(),
            'onStateChange': (e) => {
              if (e.data === YT.PlayerState.ENDED) this.hide();
            }
          }
        }
    );
  }

  #parseVideoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }
}
customElements.define('youtube-player', YoutubePlayer)

class TikTokPlayer extends PopupVideoPlayer {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  getPlayerId() {
    return "video-slider-tiktok-player"
  }

  play(url) {
    // 1. 显示弹窗
    this.showPopup()
    // 2. 检查是否已存在 iframe，存在则移除（避免重复添加）
    const existingIframe = this.playerWrapper.querySelector('iframe');
    if (existingIframe) {
      existingIframe.remove();
    }

    // 3. 创建 TikTok 官方 iframe 嵌入代码
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.tiktok.com/player/v1/${this.#extractVideoId(url)}?autoplay=0&loop=1`);
    iframe.setAttribute('allow', 'fullscreen');

    // 4. 将 iframe 添加到容器
    this.playerWrapper.appendChild(iframe);
  }

  stopPlay() {
    this.playerWrapper.querySelector('iframe')?.remove()
  }

  // 私有方法：从 URL 中提取 TikTok 视频 ID
  #extractVideoId(url) {
    // 示例 URL 格式：
    // 1. https://www.tiktok.com/@username/video/1234567890123456789
    // 2. https://vm.tiktok.com/abcdefg/
    const regex = /\/video\/(\d+)/;
    const match = url.match(regex);
    return match ? match[1] : url; // 如果无法提取，直接返回原 URL（需确保 TikTok 能处理）
  }
}
customElements.define('tiktok-player', TikTokPlayer)


class InstagramPlayer extends PopupVideoPlayer {
  static #isScriptLoading = false;
  static #isScriptLoaded = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.#loadInstagramEmbedScript();
    super.connectedCallback();
  }

  getPlayerId() {
    return "video-slider-instagram-player";
  }

  play(url) {
    this.showPopup();
    this.#loadInstagramPost(url);
  }

  stopPlay() {
    // Instagram 嵌入视频没有直接的停止方法，可以隐藏或清空容器
    this.playerWrapper.innerHTML = '';
  }

  #loadInstagramEmbedScript() {
    if (InstagramPlayer.#isScriptLoaded) return;
    if (!InstagramPlayer.#isScriptLoading) {
      InstagramPlayer.#isScriptLoading = true;
      const script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.onload = () => {
        InstagramPlayer.#isScriptLoaded = true;
      };
      document.body.appendChild(script);
    }
  }

  #loadInstagramPost(url) {
    // 清空容器
    this.playerWrapper.innerHTML = '';

    // 创建 Instagram 嵌入块
    const blockquote = document.createElement('blockquote');
    blockquote.className = 'instagram-media';
    blockquote.setAttribute('data-instgrm-permalink', url);
    blockquote.setAttribute('data-instgrm-version', '14');

    // 添加到容器
    this.playerWrapper.appendChild(blockquote);

    // 如果脚本已加载，手动初始化
    if (InstagramPlayer.#isScriptLoaded && window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }
}

customElements.define('instagram-player', InstagramPlayer);


/*
  让数字跳动，用法：
  <animate-number data-speed="1000" data-once="true">
    <span class="animate-number-target">788</span>
    <span>Suffix</span> <!-- 可选 -->
  </animate-number>
 */
class AnimateNumber extends HTMLElement {
  constructor() {
    super();
    this.endNumber = 0
    this.decimalPlaces = 0
    this.numberElement = this.querySelector('.animate-number-target')
    const numberText = this.numberElement.innerText
    if (numberText && numberText.length > 0) {
      this.endNumber = parseFloat(numberText)
      const startIndex = numberText.indexOf('.')
      if (startIndex >= 0) {
        this.decimalPlaces = numberText.substring(numberText.indexOf('.') + 1, numberText.length)?.length
      } else {
        this.decimalPlaces = 0
      }
    }
    this.speed = parseInt(this.dataset.speed || '1000')
    this.once = this.dataset.once === 'true'
  }

  connectedCallback() {
    if (this.speed > 0) {
      this.observer = new IntersectionObserver((entries, observer) => {
        if(entries[0].isIntersecting) {
          this.startAnimate()
          if (this.once) {
            this.observer.disconnect();
          }
        }
      });

      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    if(this.observer) {
      this.observer.disconnect();
    }
  }

  startAnimate() {
    this.animateNumberAdvanced({
      element: this.numberElement,
      startVal: 0,
      endVal: this.endNumber,
      duration: this.speed,
      easing: 'easeOutQuad',
      decimalPlaces: this.decimalPlaces
    });

  }

  animateNumberAdvanced(options) {
    const {
      element,
      startVal = 0,
      endVal,
      duration = 2000,
      easing = 'linear',
      format,
      decimalPlaces = 0 // 新增小数位数参数（默认0）
    } = options;
    let startTime = null;
    // 缓动函数
    const easingFunctions = {
      linear: t => t,
      easeInQuad: t => t * t,
      easeOutQuad: t => t * (2 - t),
      easeInOutQuad: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
    };
    function update(currentTime) {
      if (!startTime) startTime = currentTime;
      const elapsed = Math.min(currentTime - startTime, duration);
      const progress = elapsed / duration;
      // 计算当前值（保留足够小数位计算）
      let currentVal = (elapsed >= duration)
          ? endVal
          : startVal + (endVal - startVal) * easingFunctions[easing](progress);
      // 新增逻辑：优先使用 format，否则按 decimalPlaces 格式化
      if (format) {
        element.textContent = format(currentVal); // 交完全控制权给用户
      } else {
        // 根据小数位数格式化，例如 decimalPlaces=2 → 100.00
        const fixedVal = parseFloat(currentVal.toFixed(decimalPlaces + 2));
        element.textContent = currentVal.toLocaleString(undefined, {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
          useGrouping: true // 可选：去掉千分位分隔符
        });
      }

      if (elapsed < duration) {
        requestAnimationFrame(update);
      }
    }
    requestAnimationFrame(update);
  }

}
customElements.define('animate-number', AnimateNumber)


class VideoMedia extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.onVideoPlayingListener = this.onVideoPlaying.bind(this)
    this.onVideoPauseListener = this.onVideoPause.bind(this)
    this.onVideoEndedListener = this.onVideoEnded.bind(this)

    this.loadVideoContent()
    
    if (this.video.hasAttribute('autoplay')) {
      this.video.muted = true
      Motion.inView(this, () => {
        this.play()
      })
    }

    this.playPoster?.addEventListener('click', this.play.bind(this))
  }

  get playPoster() {
    return this.querySelector('.video-media__play-poster')
  }

  loadVideoContent() {
    const template = this.querySelector('template');
    if (!template) return;
    
    // Clone and insert the video
    const content = template.content.cloneNode(true);
    this.appendChild(content);
    
    // Find the video element
    this.video = this.querySelector('video');
    
    this.video.addEventListener('loadedmetadata', () => {
      this.setAttribute("loaded", "");
    });
  }

  connectedCallback() {
    this.video.addEventListener('playing', this.onVideoPlayingListener)
    this.video.addEventListener('pause', this.onVideoPauseListener)
    this.video.addEventListener('ended', this.onVideoEndedListener)
  }

  disconnectedCallback() {
    this.video.removeEventListener('playing', this.onVideoPlayingListener)
    this.video.removeEventListener('pause', this.onVideoPauseListener)
    this.video.removeEventListener('ended', this.onVideoEndedListener)
  }

  play() {
    this.video?.play()
  }

  pause() {
    this.video.pause()
  }

  onVideoPlaying() {
    this.setAttribute('playing', '')
    this.setAttribute('played', '')
  }

  onVideoPause() {
    this.removeAttribute('playing')
  }

  onVideoEnded() {
    this.removeAttribute('playing')
  }
}
customElements.define('video-media', VideoMedia);